import { render, staticRenderFns } from "./TaiKhoan.vue?vue&type=template&id=1fd63a82&"
import script from "./TaiKhoan.vue?vue&type=script&lang=js&"
export * from "./TaiKhoan.vue?vue&type=script&lang=js&"
import style0 from "./TaiKhoan.vue?vue&type=style&index=0&id=1fd63a82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports